import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  palette: {
    text: {
      primary: "#111827",
      secondary: "#374151",
      disabled: "#374151",
    },
  },
  typography: {
    fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
    button: { textTransform: "none", fontWeight: 600 },
    h1: { fontSize: "2rem", fontWeight: 700 },
    h2: { fontSize: "1.75rem", fontWeight: 700 },
    h3: { fontSize: "1.5rem", fontWeight: 700 },
    h4: { fontSize: "1.25rem", fontWeight: 700 },
    h5: { fontSize: "1.125rem", fontWeight: 700 },
    h6: { fontSize: "1rem", fontWeight: 600 },
  },
  components: {
    MuiTabs: {
      defaultProps: {
        variant: "scrollable",
        scrollButtons: "auto",
        allowScrollButtonsMobile: true,
      },
      styleOverrides: {
        root: ({ theme: t }) => ({
          minHeight: 48,
          [t.breakpoints.up("sm")]: { minHeight: 56 },
        }),
      },
    },
    MuiTableContainer: {
      styleOverrides: {
        root: ({ theme: t }) => ({
          maxHeight: "calc(100dvh - 280px)",
          overflow: "auto",
          overflowX: "auto",
          overflowY: "auto",
          scrollbarGutter: "stable",
          [t.breakpoints.up("md")]: {
            maxHeight: "calc(100dvh - 340px)",
          },
        }),
      },
    },
    MuiDialogContent: {
      styleOverrides: {
        root: {
          "& .MuiTableContainer-root": {
            maxHeight: "min(70vh, calc(100vh - 160px))",
            overflow: "auto",
            scrollbarGutter: "stable",
          },
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          "&:has(> .MuiTableContainer-root)": {
            overflow: "visible",
          },
        },
      },
    },
  },
});

export default theme;
